import {
  LEGALITYASSET_LOADING,
  GET_LEGALITYASSET,
  GET_LEGALITYASSET_SUCCESS,
  GET_LEGALITYASSET_FAIL,
  ADD_LEGALITYASSET_SUCCESS,
  ADD_LEGALITYASSET_FAIL,
  DELETE_LEGALITYASSET_SUCCESS,
  DELETE_LEGALITYASSET_FAIL,
  UPDATE_LEGALITYASSET_SUCCESS,
  UPDATE_LEGALITYASSET_FAIL,
  LEGALITYASSET_RESET
} from "./actionType";

const INIT_STATE = {
  legalityAssets: [],
  error: {},
};

const LegalityAsset = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LEGALITYASSET_SUCCESS:
      switch (action.payload.actionType) {
        case GET_LEGALITYASSET:
          return {
            ...state,
            legalityAssets: action.payload.data,
            isLegalityAssetCreated: false,
            isLegalityAssetSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_LEGALITYASSET_FAIL:
      switch (action.payload.actionType) {
        case GET_LEGALITYASSET_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isLegalityAssetCreated: false,
            isLegalityAssetSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_LEGALITYASSET: {
      return {
        ...state,
        isLegalityAssetCreated: false,
        loading: true,
      };
    }

    case LEGALITYASSET_LOADING: {
      return {
        ...state,
        isLegalityAssetCreated: false,
        loading: true,
      };
    }

    case ADD_LEGALITYASSET_SUCCESS:
      return {
        ...state,
        isLegalityAssetCreated: true,
        loading: false,
        legalityAssets: [action.payload.data, ...state.legalityAssets],
      };

    case ADD_LEGALITYASSET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_LEGALITYASSET_SUCCESS:
      return {
        ...state,
        loading: false,
        legalityAssets: state.legalityAssets.filter(
          civilLegalityAsset => civilLegalityAsset.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_LEGALITYASSET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_LEGALITYASSET_SUCCESS:
      return {
        ...state,
        loading: false,
        legalityAssets: state.legalityAssets.map(civilLegalityAsset =>
          civilLegalityAsset.id.toString() === action.payload.data.id.toString() ? { ...civilLegalityAsset, ...action.payload.data } : civilLegalityAsset
        ),
      };

    case UPDATE_LEGALITYASSET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case LEGALITYASSET_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default LegalityAsset;